import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { useNavigate } from 'react-router-dom';


export default function TaskBreadcrumbs({ isLoading, organizationSlug, task }) {
    const navigate = useNavigate();

    if (isLoading) {
        return (
            <div className="flex justify-between items-center h-6">
                <Breadcrumb>
                    <BreadcrumbList>
                        <BreadcrumbItem>
                            <div className="h-6 w-24 bg-muted animate-pulse rounded-md" />
                        </BreadcrumbItem>
                        <BreadcrumbSeparator />
                        <BreadcrumbItem>
                            <div className="h-6 w-32 bg-muted animate-pulse rounded-md" />
                        </BreadcrumbItem>
                        <BreadcrumbSeparator />
                        <BreadcrumbItem>
                            <div className="h-6 w-16 bg-muted animate-pulse rounded-md" />
                        </BreadcrumbItem>
                    </BreadcrumbList>
                </Breadcrumb>
            </div>
        );
    }

    return (
        <div className="flex justify-between items-center h-6">
            <Breadcrumb>
                <BreadcrumbList>
                    <BreadcrumbItem>
                        <BreadcrumbLink 
                            href={`/${organizationSlug}`}
                            onClick={(e) => {
                                e.preventDefault();
                                navigate(`/${organizationSlug}`);
                            }}
                            className="cursor-pointer"
                        >
                            {task.organization.name}
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <BreadcrumbLink 
                            href={`/${organizationSlug}/plan/${task.projectKey}/board`}
                            onClick={(e) => {
                                e.preventDefault();
                                navigate(`/${organizationSlug}/plan/${task.projectKey}/board`);
                            }}
                            className="cursor-pointer"
                        >
                            {task.project.name}
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <BreadcrumbLink 
                            href={`/${organizationSlug}/plan/${task.key}`}
                            onClick={(e) => {
                                e.preventDefault();
                                navigate(`/${organizationSlug}/plan/${task.key}`);
                            }}
                            className="cursor-pointer"
                        >
                            {task.key}
                        </BreadcrumbLink>
                    </BreadcrumbItem>
                </BreadcrumbList>
            </Breadcrumb>
        </div>
    );
}
